export const GET_VIDEOS = 'GET_VIDEOS';
export const SET_VIDEOS = 'SET_VIDEOS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_VIDEO = 'SET_VIDEO';
export const ADD_VIDEO = 'ADD_VIDEO';
export const EMPTY_VIDEO = 'EMPTY_VIDEO';
export const DELETE_VIDEO = 'DELETE_VIDEO';
export const EDIT_VIDEO = 'EDIT_VIDEO';
export const UPDATE_VIDEO = 'UPDATE_VIDEO';
export const SET_VIDEO_FILTER = 'SET_VIDEO_FILTER';